import { optimizeVideos } from '@/helpers/utils/video'

window.VideoOptimizer = optimizeVideos
